import * as React from 'react'
import parse from 'html-react-parser'
import { ArticleIcon } from './icons'

export const CoachingArticle = ({ article }) => {
  return (
    <div className="mb-6 flex flex-row justify-between space-x-9 rounded-2.5xl bg-lily-blue text-primary">
      <div className="self-center p-6 md:col-span-3 lg:col-span-4">
        <div className="!mb-3 flex items-center">
          <div>
            <ArticleIcon />
          </div>
          <h2
            className="!mt-0 ml-2 text-xl font-bold"
            tabIndex="0"
            role="heading"
            aria-level="2"
          >
            {article.title}
          </h2>
        </div>
        <div className="mb-3 mt-0 line-clamp-3 flex-grow">
          {article.description}
        </div>
        <div className="flex flex-row items-center">
          <a
            className="op-btn inline-flex h-10 max-w-min items-center justify-center gap-4 whitespace-nowrap rounded-full bg-primary-button px-8 py-2 font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary-button-darker-75 hover:text-white focus:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:text-white disabled:pointer-events-none disabled:opacity-50"
            target="_self"
            href={article.buttonUrl}
            rel="noreferrer noopener"
            aria-label={article.buttonText}
          >
            {parse(article.buttonText)}
          </a>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${article.imageUrl})`,
        }}
        className="overflow-none tw-hidden visible w-full rounded-r-2.5xl bg-cover bg-center bg-no-repeat object-fill md:block md:min-w-[255px] md:max-w-[255px]"
      ></div>
    </div>
  )
}
